// extracted by mini-css-extract-plugin
module.exports = {"archiveButton":"ArchiveAction_archiveButton__1iopO"};